var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CreditStatus/Pending"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse",
    d: "M14.7509 8.00135C14.7509 11.73 11.7282 14.7527 7.99951 14.7527C4.27084 14.7527 1.24816 11.73 1.24816 8.00135C1.24816 4.2727 4.27084 1.25 7.99951 1.25C11.7282 1.25 14.7509 4.2727 14.7509 8.00135Z",
    fill: "#FFC600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M7.44727 10.0716H8.65351V11.1968H7.44727V10.0716ZM7.49227 4.76949H8.6175V6.62386L8.32044 9.40542H7.78933L7.49227 6.62386V4.76949Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.2cccf4a019cf70d5d4935ff2909ad424.svg";
export { ForwardRef as ReactComponent };